import script from "./ConsultBoardDetailPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConsultBoardDetailPage.vue?vue&type=script&setup=true&lang=ts"

import "./ConsultBoardDetailPage.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__